import { render } from "./MontargetAgent.vue?vue&type=template&id=e9bcab42&scoped=true"
import script from "./MontargetAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./MontargetAgent.vue?vue&type=script&setup=true&lang=js"

import "./MontargetAgent.vue?vue&type=style&index=0&id=e9bcab42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9bcab42"],['__file',"src/containers/popup/MontargetAgent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e9bcab42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e9bcab42', __exports__)) {
    api.reload('e9bcab42', __exports__)
  }
  
  module.hot.accept("./MontargetAgent.vue?vue&type=template&id=e9bcab42&scoped=true", () => {
    api.rerender('e9bcab42', render)
  })

}


export default __exports__